import React from 'react';
import { DataTypeProvider } from '@devexpress/dx-react-grid';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';

const FirstPageFormatter = ({ row }) => {
  return row.first_page
    ? <StarIcon style={{ color: '#f5a623', fontSize: 20 }} titleAccess="First Page" />
    : <StarBorderIcon style={{ color: '#ccc', fontSize: 20 }} titleAccess="Not First Page" />;
};

const FirstPageTypeProvider = props => <DataTypeProvider formatterComponent={FirstPageFormatter} {...props} />;

export default FirstPageTypeProvider;
